import "./AboutContentStyles.css";

import me1 from "../assets/me1.jpeg";
import me2 from "../assets/me2.jpeg";

const AboutContent = () => {
  return (
    <>
      <div className="about">
        <div className="left">
          <h1>Who am I?</h1>
          {/* <p>
            Hey there! I'm Yeshas, a student at UT Dallas majoring in Computer
            Science. My interests are in anything AI, ML, and data science
            related. I enjoy learning new things and participating in
            hackathons.{" "}
          </p>
          <p>
            In addition, I enjoy watching and playing sports, being outdoors,
            and puzzles.
          </p> */}
          <p>
            Studied CS @ UT Dallas
          </p>
          <p>
            Professional experience with mobile + fullstack development in the monetization and sports industries
          </p>
          <p>
            Enjoy building things and being outdoors
          </p>
        </div>
        <div className="right">
          <div className="img-container">
            <div className="img-stack top">
              <img src={me1} className="img" alt="true" />
            </div>
            <div className="img-stack bottom">
              <img src={me2} className="img" alt="true" />
            </div>
          </div>
        </div>
      </div>
      <div className="info-container">
        <div className="card">
          <span>Experience</span>
          <div className="info">
            <p>
              <b>Software Engineer</b> @ Meta
            </p>
            <p>
              <b>Software Engineer Intern</b> @ Meta
            </p>
            <p>
              <b>Software Engineer Intern</b> @ Bank of America
            </p>
            <p>
              <b>Data Ops Intern (SWE + DS)</b> @ Driveline Baseball
            </p>
            <p>
              <b>Creator</b> @ Pitch Predictor
            </p>
            <p>
              <b>Freelance Software Engineer</b>
            </p>
          </div>
        </div>
        <div className="card">
          <span>Languages</span>
          <div className="info">
            <ul>
              <li>
                <b>Java</b> 
              </li>
              <li>
                <b>Python</b> 
              </li>
              <li>
                <b>Swift</b> 
              </li>
              <li>
                <b>Hack</b> 
              </li>
              <li>
                <b>Javascript</b>
              </li>
            </ul>
          </div>
        </div>
        <div className="card">
          <span>Other</span>
          <div className="info">
            <ul>
              <li>
                <b>Large Language Models</b>
              </li>
              <li>
                <b>Natural Language Processing</b>
              </li>
               <li>
                <b>Computer Vision</b>
              </li>
              <li>
                <b>Tensorflow</b>
              </li>
              <li>
                <b>React + NodeJS</b>
              </li>
              <li>
                <b>Git</b>
              </li>
              <li>
                <b>Linux</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutContent;
